import { COMPANY } from "../data/content";
import { scrollToSection } from "./Navbar";

export const Footer = () => (
  <footer data-testid="site-footer" className="blueprint-grid-dark bg-navy-deep text-white">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <p className="font-display text-3xl font-black tracking-tight">
            SUBHANKARA<span className="text-electric">.</span>
          </p>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-blue-200/70">
            {COMPANY.name} — interior consulting, civil &amp; structural design,
            project management and government estimation services.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-[10px] font-bold uppercase tracking-[0.25em] text-blue-300">Visit</p>
          <p className="mt-3 text-sm leading-relaxed text-blue-100/85">{COMPANY.address}</p>
          <p className="mt-3 font-mono text-xs text-blue-200/70">{COMPANY.hours}</p>
          <p className="font-mono text-xs text-blue-200/70">{COMPANY.closed}</p>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono text-[10px] font-bold uppercase tracking-[0.25em] text-blue-300">Talk</p>
          <a href={`tel:${COMPANY.phoneRaw}`} data-testid="footer-phone" className="mt-3 block text-sm text-blue-100/85 transition-colors hover:text-white">
            {COMPANY.phone}
          </a>
          <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="mt-1 block text-sm text-blue-100/85 transition-colors hover:text-white">
            {COMPANY.email}
          </a>
          <button
            data-testid="footer-enquire-button"
            onClick={() => scrollToSection("#contact")}
            className="mt-5 border border-electric bg-electric px-5 py-2.5 font-mono text-xs font-bold uppercase tracking-[0.15em] text-white transition-colors hover:bg-transparent"
          >
            Enquire Now
          </button>
        </div>
      </div>
      <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-blue-200/50">
          © {new Date().getFullYear()} {COMPANY.name} · Est. {COMPANY.established}
        </p>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-blue-200/50">
          Designed & built in Patna, Bihar
        </p>
      </div>
    </div>
  </footer>
);
